/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var GrinWinkIcon = createIcon({
  name: 'GrinWinkIcon',
  height: 512,
  width: 496,
  svgPath: 'M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default GrinWinkIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/grin-wink-icon.js
// module id = 651
// module chunks = 0